import { render, staticRenderFns } from "./AnswerExplaination.vue?vue&type=template&id=086d4fa2&scoped=true"
import script from "./AnswerExplaination.vue?vue&type=script&lang=js"
export * from "./AnswerExplaination.vue?vue&type=script&lang=js"
import style0 from "./AnswerExplaination.vue?vue&type=style&index=0&id=086d4fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d4fa2",
  null
  
)

export default component.exports